import { render, staticRenderFns } from "./BindThree.vue?vue&type=template&id=28e08ef3&scoped=true"
import script from "./BindThree.vue?vue&type=script&lang=js"
export * from "./BindThree.vue?vue&type=script&lang=js"
import style0 from "./BindThree.vue?vue&type=style&index=0&id=28e08ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e08ef3",
  null
  
)

export default component.exports